function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnMenuChatbot = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 186",
  style: {
    fill: "none"
  },
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.625 8.25h-.458v-.917a4.589 4.589 0 0 0-4.584-4.583h-3.666V.917a.917.917 0 1 0-1.833 0V2.75H6.417a4.589 4.589 0 0 0-4.584 4.583v.917h-.458A1.377 1.377 0 0 0 0 9.625v2.75a1.377 1.377 0 0 0 1.375 1.375h.458v.917a4.589 4.589 0 0 0 4.584 4.583h7.056l3.627 2.422a1.969 1.969 0 0 0 3.062-1.639v-6.284h.458A1.377 1.377 0 0 0 22 12.374v-2.75a1.377 1.377 0 0 0-1.375-1.375zM7.792 7.333a1.375 1.375 0 1 1-1.375 1.375 1.376 1.376 0 0 1 1.375-1.375zm7.362 6.942A8.011 8.011 0 0 1 11 15.583a8.011 8.011 0 0 1-4.153-1.308.917.917 0 0 1 .974-1.553A6.192 6.192 0 0 0 11 13.75a6.2 6.2 0 0 0 3.18-1.028.917.917 0 0 1 .974 1.553zm-.945-4.192a1.375 1.375 0 1 1 1.375-1.375 1.376 1.376 0 0 1-1.376 1.375z",
  transform: "translate(3 1.997)",
  style: {
    fill: "#fff"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnMenuChatbot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "f1eb9097f6c97c3ca9a86ccd4e77b262.svg";